"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.autosave = autosave;
exports.bulkCreate = bulkCreate;
exports.bulkInvite = bulkInvite;
exports.bulkValidate = bulkValidate;
exports.convertCurrency = convertCurrency;
exports.createFollowUpEpl = createFollowUpEpl;
exports["default"] = void 0;
exports.fetchRecordingsFromEplId = fetchRecordingsFromEplId;
exports.get = get;
exports.getEmployeeSubmitted = getEmployeeSubmitted;
exports.getEplStatuses = getEplStatuses;
exports.getExternLink = getExternLink;
exports.getExternLinks = getExternLinks;
exports.getHiddenExperienceFields = getHiddenExperienceFields;
exports.getHiddenExperiences = getHiddenExperiences;
exports.getLoggedEvents = getLoggedEvents;
exports.getRecordingsFromEplHash = getRecordingsFromEplHash;
exports.getScheduleByEplId = getScheduleByEplId;
exports.getZoomRecordingCount = getZoomRecordingCount;
exports.inviteToProject = inviteToProject;
exports.recalculateMargin = recalculateMargin;
exports.remove = remove;
exports.save = save;
exports.saveScheduleSettings = saveScheduleSettings;
exports.sendExtractEplEmail = sendExtractEplEmail;
exports.sendGenericLinks = sendGenericLinks;
exports.sendIndividualLink = sendIndividualLink;
exports.sendRejectionEmail = sendRejectionEmail;
exports.setNameVisibility = setNameVisibility;
exports.setSegmentForEpls = setSegmentForEpls;
exports.setStatusForEpls = setStatusForEpls;
exports.updateDeliveredBy = updateDeliveredBy;

var _api = _interopRequireWildcard(require("./api"));

var _pick = _interopRequireDefault(require("lodash/pick"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var base = '/api/expert-project-link';
/**
 * Will make sure only relevant data is sent to server.
 *
 * @param {Object} rawEplFormData
 */

function cleanupData(rawEplFormData) {
  var formData = (0, _pick["default"])(rawEplFormData, ['industryExpertise', 'screening', 'relevantExperienceId', 'overwriteExpertIndustryExpertise', 'honorariumCurrencyId', 'honorarium', 'free', 'feeCurrencyId', 'fee', 'credits', 'pricingId', 'expertAvailability', 'hiddenExperienceIds', 'cvId', 'fieldsHiddenToExpert', 'experiencesHiddenToExpert']);

  if (formData.honorarium === '') {
    formData.honorarium = null;
  }

  return formData;
}

function get(eplId) {
  return _api["default"].get("".concat(base, "/").concat(eplId)).then(_api.extractData)["catch"](_api.errorHandler);
}

function save(eplId, eplFormData, hiddenExperienceIds) {
  var fieldsHiddenToExpert = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var experiencesHiddenToExpert = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var eplData = cleanupData(_objectSpread(_objectSpread({}, eplFormData), {}, {
    hiddenExperienceIds: hiddenExperienceIds,
    fieldsHiddenToExpert: fieldsHiddenToExpert,
    experiencesHiddenToExpert: experiencesHiddenToExpert
  }));
  return _api["default"].put("".concat(base, "/").concat(eplId, "/v2"), eplData).then(_api.extractData)["catch"](_api.errorHandler);
}

function autosave(eplId, eplData) {
  return _api["default"].put("".concat(base, "/").concat(eplId, "/expanded"), eplData).then(_api.extractData)["catch"](_api.errorHandler);
}

function setNameVisibility(eplId, payload) {
  return _api["default"].put("".concat(base, "/").concat(eplId, "/name-visibility"), payload).then(_api.extractData)["catch"](_api.errorHandler);
}

function updateDeliveredBy(eplId, payload) {
  return _api["default"].put("".concat(base, "/").concat(eplId, "/delivered-by"), payload).then(_api.extractData)["catch"](_api.errorHandler);
}

function saveScheduleSettings(eplId, scheduleData) {
  return _api["default"].post("".concat(base, "/").concat(eplId, "/schedule"), scheduleData).then(_api.extractData)["catch"](_api.errorHandler);
}

function getEmployeeSubmitted(eplId) {
  return _api["default"].get("".concat(base, "/").concat(eplId, "/employee-submitted")).then(_api.extractData)["catch"](_api.errorHandler);
}

function getHiddenExperiences(eplId) {
  return _api["default"].get("".concat(base, "/").concat(eplId, "/hidden-experiences")).then(_api.extractData)["catch"](_api.errorHandler);
}

function getHiddenExperienceFields(eplId) {
  return _api["default"].get("".concat(base, "/").concat(eplId, "/hidden-experience-fields")).then(_api.extractData)["catch"](_api.errorHandler);
}

function getZoomRecordingCount(eplId) {
  return _api["default"].get("/api/zoom-recording/count-by-epl/".concat(eplId)).then(_api.extractData)["catch"](_api.errorHandler);
}

function remove(eplId) {
  return _api["default"]["delete"]('/api/expert-project-link/' + eplId).then(_api.extractData)["catch"](_api.errorHandler);
}
/**
 * Returns all the EPL statuses and possible transitions
 */


function getEplStatuses() {
  return _api["default"].get('/api/epl-status').then(_api.extractData)["catch"](_api.errorHandler);
}

function getExternLink(eplId, isEplExtract) {
  var url = "/api/expert-project-link/".concat(eplId, "/extern-link");

  if (isEplExtract) {
    url = "".concat(url, "?isEplExtract=true");
  }

  return _api["default"].post(url).then(_api.extractData)["catch"](_api.errorHandler);
}

function getExternLinks(eplId) {
  return _api["default"].post("/api/expert-project-link/".concat(eplId, "/extern-links")).then(_api.extractData)["catch"](_api.errorHandler);
}

function inviteToProject(eplId, data) {
  return _api["default"].post("/api/expert-project-link/".concat(eplId, "/invite-to-project"), data).then(_api.extractData)["catch"](_api.errorHandler);
}

function bulkCreate(eplsData) {
  return _api["default"].post('/api/expert-project-link/bulk-create', eplsData).then(_api.extractData)["catch"](_api.errorHandler);
}

function bulkValidate(data) {
  return _api["default"].post('/api/expert-project-link/bulk-validate', data).then(_api.extractData)["catch"](_api.errorHandler);
}

function bulkInvite(data) {
  return _api["default"].post('/api/expert-project-link/bulk-invite-to-project', data).then(_api.extractData)["catch"](_api.errorHandler);
}
/**
 * Calls the Zoom api and upserts zoomRecordings for a certain epl. Caution: api is rate-limited at 10 req/sec.
 *
 * @param {string} eplId
 */


function fetchRecordingsFromEplId(eplId) {
  var endpoint = "/api/zoom-recording/lookup/".concat(eplId);
  return _api["default"].post(endpoint).then(_api.extractData)["catch"](_api.errorHandler);
}

function getRecordingsFromEplHash(eplHash) {
  var endpoint = "/api/recording/extern/".concat(eplHash);
  return _api["default"].get(endpoint).then(_api.extractData)["catch"](_api.errorHandler);
}

function setSegmentForEpls(segmentId, eplIds) {
  var endpoint = "/api/segment/".concat(segmentId, "/expert-project-link");
  return _api["default"].put(endpoint, {
    eplIds: eplIds
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function setStatusForEpls(eplStatusId, eplIds) {
  var endpoint = "/api/expert-project-link/status/".concat(eplStatusId);
  return _api["default"].put(endpoint, {
    eplIds: eplIds
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function getLoggedEvents(eventType, eplId) {
  return _api["default"].post('/api/logged-event/query', {
    eventType: eventType,
    eventIds: [eplId]
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function recalculateMargin(_ref) {
  var fee = _ref.fee,
      honorarium = _ref.honorarium,
      feeCurrencyId = _ref.feeCurrencyId,
      honorariumCurrencyId = _ref.honorariumCurrencyId;
  return _api["default"].post('/api/expert-project-link/margin', {
    fee: fee,
    honorarium: honorarium,
    feeCurrencyId: feeCurrencyId,
    honorariumCurrencyId: honorariumCurrencyId
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function sendExtractEplEmail(data) {
  return _api["default"].post('/api/expert-project-link/send-extract-epls-email', data).then(_api.extractData)["catch"](_api.errorHandler);
}

function sendRejectionEmail(eplId, projectId) {
  return _api["default"].post("/api/expert-project-link/".concat(eplId, "/send-rejection-email"), {
    projectId: projectId
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function convertCurrency(_ref2) {
  var amount = _ref2.amount,
      fromCurrencyId = _ref2.fromCurrencyId,
      toCurrencyId = _ref2.toCurrencyId;
  return _api["default"].post('/api/expert-project-link/convert-fee-currency', {
    amount: amount,
    fromCurrencyId: fromCurrencyId,
    toCurrencyId: toCurrencyId
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function getScheduleByEplId(eplId) {
  return _api["default"].get("/api/expert-project-link/".concat(eplId, "/epl-schedule")).then(_api.extractData)["catch"](_api.errorHandler);
}

function createFollowUpEpl(eplId, status) {
  return _api["default"].post("/api/expert-project-link/create-capi-follow-up-epl", {
    eplId: eplId,
    status: status
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function sendIndividualLink(projectId) {
  var userId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return _api["default"].post("/api/expert-project-link/".concat(projectId, "/individual-link"), {
    userId: userId
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function sendGenericLinks(projectId) {
  return _api["default"].post("/api/expert-project-link/".concat(projectId, "/generic-link")).then(_api.extractData)["catch"](_api.errorHandler);
}

var api = {
  get: get,
  save: save,
  autosave: autosave,
  remove: remove,
  setNameVisibility: setNameVisibility,
  updateDeliveredBy: updateDeliveredBy,
  saveScheduleSettings: saveScheduleSettings,
  getEmployeeSubmitted: getEmployeeSubmitted,
  getHiddenExperiences: getHiddenExperiences,
  getHiddenExperienceFields: getHiddenExperienceFields,
  getEplStatuses: getEplStatuses,
  getZoomRecordingCount: getZoomRecordingCount,
  fetchRecordingsFromEplId: fetchRecordingsFromEplId,
  getRecordingsFromEplHash: getRecordingsFromEplHash,
  inviteToProject: inviteToProject,
  bulkCreate: bulkCreate,
  bulkValidate: bulkValidate,
  bulkInvite: bulkInvite,
  recalculateMargin: recalculateMargin,
  setSegmentForEpls: setSegmentForEpls,
  getLoggedEvents: getLoggedEvents,
  getExternLink: getExternLink,
  getExternLinks: getExternLinks,
  sendExtractEplEmail: sendExtractEplEmail,
  sendRejectionEmail: sendRejectionEmail,
  convertCurrency: convertCurrency,
  getScheduleByEplId: getScheduleByEplId,
  createFollowUpEpl: createFollowUpEpl,
  sendIndividualLink: sendIndividualLink,
  sendGenericLinks: sendGenericLinks
};
var _default = api;
exports["default"] = _default;